import { Control, Controller, Path, FieldValues } from 'react-hook-form'
import { SelectField } from 'components/Custom/SelectField'
import { TextFieldProps } from '@mui/material'

export type SelectMenuItem = { value: string | number; label: string }

interface SelectInputControllerProps<T extends FieldValues> extends Omit<TextFieldProps, 'error'> {
  control: Control<T>
  errors?: string
  disabled?: boolean
  name: Path<T>
  label: string
  className?: string
  menuItems: SelectMenuItem[]
  defaultValue?: string
  rightIcon?: boolean
}

export const SelectInputController = <T extends FieldValues>({
  control,
  errors,
  disabled = false,
  name,
  label,
  className = '',
  menuItems,
  defaultValue,
  rightIcon = false,
  ...textFieldProps
}: SelectInputControllerProps<T>) => (
  <Controller<T>
    control={control}
    name={name}
    render={({ field }) => (
      <SelectField
        {...field}
        description={label}
        menuItems={menuItems}
        className={className}
        error={!!errors}
        disabled={disabled}
        defaultValue={defaultValue}
        helperText={errors}
        rightIcon={rightIcon}
        {...textFieldProps}
      />
    )}
  />
)
